import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import About from './pages/about/About';
import Home from './pages/home/Home';
import OurTeam from './pages/our-team/OurTeam';
import Companies from './pages/companies/Companies';
import Contact from './pages/contact/Contact';
import WorkingAtForager from './pages/working-at-forager/WorkingAtForager';
import ForagerMediaGroup from './pages/forager-media-group/ForagerMediaGroup';
import ForagerFinancial from './pages/forager-financial/ForagerFinancial';
import ForagerEducation from './pages/forager-education/ForagerEducation';
import News from "./pages/news/News";
import MissionAndValues from './pages/mission-and-values/MissionAndValues';
import NotFoundPage from "./pages/errors/NotFoundPage";

const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/companies', element: <Companies /> },
  { path: '/our-team', element: <OurTeam /> },
  { path: '/working-at-forager', element: <WorkingAtForager /> },
  { path: '/news', element: <News /> },
  { path: '/contact', element: <Contact /> },
  { path: '/mission-and-values', element: <MissionAndValues /> },
  { path: '/companies/forager-media-group', element: <ForagerMediaGroup /> },
  { path: '/companies/forager-financial', element: <ForagerFinancial /> },
  { path: '/companies/forager-education', element: <ForagerEducation /> },
  { path: '*', element: <NotFoundPage/> }
]);

export default router;
